import React, { useState, useEffect } from "react";
import "../../styles/settings/changePassword.css";
import { changePasswordURL } from "../../api/endpoints";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";
import { ButtonLoaderII } from "../../components/uxCollections/Loaders";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const checkPasswordValidation = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
    return passwordRegex.test(password);
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmPassword) {
      uiAlert("New password and confirmation do not match.", "error");
      return;
    }
    // check password validation
    const isValid = checkPasswordValidation(formData.newPassword);
    if (!isValid) {
      uiAlert("New password must contain at least 8 characters, one uppercase letter, one lowercase letter, and one number.", "warning");
      return;
    }
    try {
      setIsLoading(true);
      let response = await fetch(changePasswordURL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword,
        }),
      });
      if (response.status === 401) {
        uiAlert("your password is incorrect, please try again", "error");
        return;
      }
      if (!response.ok) {
        throw new Error("Failed to change password");
      }
      const data = await response.json();
      uiAlert(data.message || "Password changed successfully!", "success");
    } catch (error) {
      console.error("Error changing password:", error);
      uiAlert("Failed to change password. Please try again.", "error");
    } finally {
      // Reset form data after submission
      setFormData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setShowPasswords({
        current: false,
        new: false,
        confirm: false,
      });
      setIsLoading(false);
    }
    // Reset form after successful submission
  };

  return (
    <div className='cp-main-content'>
      <div className='cp-content-container'>
        <div className='cp-header'>
          <h1 className='cp-title privacy-data-info-title cp-title'>Change Password</h1>
          <p className='cp-subtitle'>Update your password to keep your account secure</p>
        </div>

        <form className='cp-form' onSubmit={handleSubmit}>
          <div className='cp-form-group'>
            <label htmlFor='currentPassword' className='cp-form-label'>
              Current Password
            </label>
            <div className='cp-input-wrapper'>
              <input
                type={showPasswords.current ? "text" : "password"}
                id='currentPassword'
                name='currentPassword'
                value={formData.currentPassword}
                onChange={handleInputChange}
                className='cp-form-input'
                placeholder='Enter your current password'
                required
              />
              <button type='button' className='cp-toggle-password' onClick={() => togglePasswordVisibility("current")}>
                {showPasswords.current ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
          </div>

          <div className='cp-form-group'>
            <label htmlFor='newPassword' className='cp-form-label'>
              New Password
            </label>
            <div className='cp-input-wrapper'>
              <input
                type={showPasswords.new ? "text" : "password"}
                id='newPassword'
                name='newPassword'
                value={formData.newPassword}
                onChange={handleInputChange}
                className='cp-form-input'
                placeholder='Enter your new password'
                required
              />
              <button type='button' className='cp-toggle-password' onClick={() => togglePasswordVisibility("new")}>
                {showPasswords.new ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
            <div className='cp-password-requirements'>
              <p className='cp-requirements-title'>Password must contain:</p>
              <ul className='cp-requirements-list'>
                <li className='cp-requirement-item'>At least 8 characters</li>
                <li className='cp-requirement-item'>One uppercase letter</li>
                <li className='cp-requirement-item'>One lowercase letter</li>
                <li className='cp-requirement-item'>One number</li>
              </ul>
            </div>
          </div>

          <div className='cp-form-group'>
            <label htmlFor='confirmPassword' className='cp-form-label'>
              Confirm New Password
            </label>
            <div className='cp-input-wrapper'>
              <input
                type={showPasswords.confirm ? "text" : "password"}
                id='confirmPassword'
                name='confirmPassword'
                value={formData.confirmPassword}
                onChange={handleInputChange}
                className='cp-form-input'
                placeholder='Confirm your new password'
                required
              />
              <button type='button' className='cp-toggle-password' onClick={() => togglePasswordVisibility("confirm")}>
                {showPasswords.confirm ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
          </div>

          <div className='cp-form-actions'>
            <button type='button' className='cp-btn-cancel'>
              Cancel
            </button>
            <button disabled={isLoading} type='submit' className='cp-btn-submit'>
              {isLoading ? <ButtonLoaderII size={20} color='#fff' /> : "Update Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
